<template>
  <q-field>
    <div class="row no-wrap">
      <q-input
        name="discount"
        :value="discountValue | asDecimal(isAbsoluteDiscount)"
        type="number"
        class="col no-shadow"
        :placeholder="$t('discount')"
        @input="handleDiscountUpdate"
        v-bind="$attrs"
      />

      <q-btn-dropdown
        flat
        dense
        :label="isAbsoluteDiscount ? currencySymbol : '%'"
        style="margin-top: 9px"
      >
        <q-list link>
          <q-item v-close-overlay @click.native="handleChangeDiscountType('abs')">
            <q-item-side :letter="currencySymbol"></q-item-side>
            <q-item-main>
              <q-item-tile label>{{ $t('absolute')}}</q-item-tile>
            </q-item-main>
          </q-item>

          <q-item v-close-overlay @click.native="handleChangeDiscountType('rel')">
            <q-item-side letter="%"></q-item-side>
            <q-item-main>
              <q-item-tile label>{{ $t('relative')}}</q-item-tile>
            </q-item-main>
          </q-item>
        </q-list>
      </q-btn-dropdown>
    </div>
  </q-field>
</template>

<script>
  import Decimal from 'decimal.js'
  import { getCurrencySymbol } from 'src/utils/money'

  export default {
    props: {
      discountAbsolute: {
        type: Number
      },

      discountRelative: {
        type: Number
      },

      type: {
        type: String,
        default: 'abs'
      },

      currency: {
        type: String,
        required: true
      }
    },

    data () {
      return {
        discountType: this.type,
        discountValue: this.discountAbsolute || this.discountRelative
      }
    },

    computed: {
      currencySymbol () {
        return getCurrencySymbol(this.currency)
      },

      isAbsoluteDiscount () {
        return this.discountType === 'abs'
      }
    },

    methods: {
      handleDiscountUpdate (value) {
        if (!value) {
          return this.resetDiscount()
        }

        if (this.isAbsoluteDiscount) {
          this.handleAbsoluteDiscountChange(value)
        } else {
          this.handleRelativeDiscountChange(value)
        }
      },

      handleChangeDiscountType (type) {
        this.discountType = type

        this.resetDiscount()
      },

      handleAbsoluteDiscountChange (value) {
        if (typeof value !== 'number') {
          return
        }

        this.discountValue = new Decimal(value).times(100).toNumber()

        this.$emit('inputDiscountAbsolute', this.discountValue)
      },

      handleRelativeDiscountChange (value) {
        this.discountValue = value

        this.$emit('inputDiscountRelative', this.discountValue)
      },

      resetDiscount () {
        this.discountValue = null

        this.$emit('inputDiscountRelative', null)
        this.$emit('inputDiscountAbsolute', null)
      }
    },

    watch: {
      discountAbsolute (val) {
        this.discountValue = val
      },

      discountRelative (val) {
        this.discountValue = val
      },

      type (val) {
        this.discountType = val
      }
    },

    filters: {
      asDecimal (value, isAbsoluteDiscount) {
        if (typeof value !== 'number') {
          return
        }

        if (!isAbsoluteDiscount) {
          return value
        }

        return new Decimal(value).dividedBy(100).toFixed(2)
      }
    }
  }
</script>
